import { getHpSmartUrl, isDevStack } from '@uma/react-commons/dist/index';

export const getHPSmartPrinterOverviewUrl = (): string => {
  return `${getHpSmartUrl()}/my-printers`;
};

export const getHPSmartManageDeviceUsersAndSharingUrl = (): string => {
  return `${getHpSmartUrl()}/account-details/manage-users`;
};

export const getHPSupportUrl = (): string => {
  return isDevStack() ? 'https://uat.support.hp.com' : 'https://support.hp.com';
};

export const URLS = {
  DevicesPurchased:
    'https://www.hp.com/us-en/shop/AccountMyDevicesView?catalogId=10051&langId=-1&storeId=10151',
  DeviceSupportNotShown: `${getHPSupportUrl()}`,
  DeviceSupport: `${getHPSupportUrl()}/dashboard/device`,
  SupportDashboard: `${getHPSupportUrl()}/dashboard`,
  ManageInstantInk: '',
  HPCarePack: '',
  Register: 'https://www.register.hp.com/'
};
